export default "__VITE_ASSET__c118fe47__"